import React, { useEffect } from 'react';
import dayjs from 'dayjs';

import Text from '~components/atoms/Text';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum, GoldTypeEnum, MetalTypeEnum, SilverTypeEnum, TransactionStatusEnum } from '~utils/enums';

import ReceiptPDF from './ReceiptPDF';
import * as ReceiptStyles from './_customerCollateralDetails.module.scss';
import combinedActions from '~redux/combinedActions';

const CustomerCollateralDetails = () => {
    const allCustomerCollateral = useAppSelector(state => state.customer.customerCollateral.data);
    const customerDetails = useAppSelector((state) => state.customer.customerDetails);
    const selectedCollateralId = useAppSelector((state) => state.customer.tempCollateralState.collateralId);

    const branches = useAppSelector(state => state.branch.allBranches);

    const selectedCustomerCollateral = allCustomerCollateral.find((collateral) => collateral.collateralId === selectedCollateralId);

    if (!selectedCustomerCollateral) return;

    const collateralBranch = branches.find(branch => branch.branchId === selectedCustomerCollateral.branchId);

    const collateralBranchName = collateralBranch?.branchName ?? '-';
    const collateralBranchCode = collateralBranch?.branchCode ?? '-';
    const collateralRegionName = collateralBranch?.regionName ?? '-';

    const getRegisterCategory = () => {
        const metalTypeName = selectedCustomerCollateral.metalType === MetalTypeEnum.Gold
            ? 'Paper Gold'
            : 'Paper Silver';

        return `${FundTypeEnum[selectedCustomerCollateral.fundType]} | ${metalTypeName}`;
    };

    const summaryTable = [
        {
            label: 'Collateral Status',
            value: TransactionStatusEnum[selectedCustomerCollateral.status],
        },
        {
            label: 'Collateral Date',
            value: dayjs(new Date()).format('DD/MM/YYYY hh:mm A'),
        },
        {
            label: 'Collateral End Date',
            value: selectedCustomerCollateral.collateralEndDate ? dayjs(selectedCustomerCollateral.collateralEndDate).format('DD/MM/YYYY hh:mm A') : '-',
        },
        // {
        //     label: 'Project Name',
        //     value: buyOrSellGoldParams.projectName ? buyOrSellGoldParams.projectName : '-',
        // },
        {
            label: 'Region Name',
            value: collateralRegionName,
        },
        {
            label: 'Branch Name',
            value: collateralBranchName,
        },
        {
            label: 'Branch Code',
            value: collateralBranchCode,
        },
        {
            label: 'Register Category',
            value: getRegisterCategory(),
        },
        {
            label: 'Name of Customer/Company Firm/Association',
            value: customerDetails.name,
        },
        {
            label: 'Identification No.',
            value: customerDetails.idNo,
        },
        {
            label: 'CIF No.',
            value: customerDetails.CIFNo,
        },
        {
            label: 'Price per gram (MYR)',
            value: selectedCustomerCollateral.paramGoldPrice === null ? `RM${(Math.round(Number(selectedCustomerCollateral.baseAPIPrice) * 100) / 100).toFixed(2)}` : `RM${(Math.round(Number(selectedCustomerCollateral.paramGoldPrice) * 100) / 100).toFixed(2)}`,
        },
        {
            label: 'Quantity',
            value: selectedCustomerCollateral.amount,
        },
        {
            label: 'Total Amount (MYR)',
            value: `RM${(Math.round(Number(selectedCustomerCollateral.marketValue) * 100) / 100).toFixed(2)}`,
        },
    ];

    const productTableHeader = ['Product', 'Price per gram (MYR)'];
    const productTableData = [selectedCustomerCollateral.productName, (selectedCustomerCollateral.paramGoldPrice === null ? `RM${(Math.round(Number(selectedCustomerCollateral.baseAPIPrice) * 100) / 100).toFixed(2)}` : `RM${(Math.round(Number(selectedCustomerCollateral.paramGoldPrice) * 100) / 100).toFixed(2)}`)];

    return (
        <div className={ReceiptStyles.container}>
            <table className={ReceiptStyles['details-table']}>
                <tbody>
                    {summaryTable.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.label}</td>
                                <td>{item.label === 'Serial No.' ? item.value : `: ${item.value}`}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className={ReceiptStyles['product-container']}>
                <Text
                    label='Description'
                    isBold
                />

                <table>
                    <tbody>
                        <tr>
                            {productTableHeader.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>

                        <tr>
                            {productTableData.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={ReceiptStyles['button-container']}>
                <ReceiptPDF
                    collateralDetails={selectedCustomerCollateral}
                    customerDetails={customerDetails}
                    collateralBranchDetails={collateralBranch}
                />
            </div>
        </div>
    );
};

export default CustomerCollateralDetails;
